import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.opener = document.activeElement
    this.element.querySelector("button")?.focus()
  }

  disconnect() {
    document.body.style.overflow = ""
    if (this.opener?.isConnected) this.opener.focus({ preventScroll: true })
  }

  close() {
    document.getElementById("admin-drawer-root")?.replaceChildren()
    document.body.style.overflow = ""
  }

  loaded() {
    this.element.querySelector("[data-admin-charity-insights-heading]")?.focus({ preventScroll: true })
    const body = this.element.querySelector(".admin-drawer-body")
    if (body) body.scrollTop = 0
  }

  failed() {
    const error = this.element.querySelector(".admin-insight-error")
    if (error) error.hidden = false
  }

  missing(event) {
    event.preventDefault()
    // A session may have expired. Never inject a redirected login/public page.
    this.failed()
  }

  keydown(event) {
    if (event.key === "Escape") {
      event.preventDefault()
      this.close()
    } else if (event.key === "Tab") {
      const items = [...this.element.querySelectorAll('a[href], button:not(:disabled), [tabindex="0"]')]
        .filter(element => element.getClientRects().length)
      const first = items[0], last = items[items.length - 1]
      if (event.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) {
        event.preventDefault(); last?.focus()
      } else if (!event.shiftKey && (document.activeElement === last || !this.element.contains(document.activeElement))) {
        event.preventDefault(); first?.focus()
      }
    }
  }
}
